// @ts-nocheck
import React, { useState } from "react";
import {
	CustomSelect,
	QuerySelect,
} from "components/Inputs/CustomAsyncSelect/CustomAsyncSelect";
import { components } from "react-select";
import FormInput from "components/Inputs/FormInput";
import "./CustomPagesNames.css";
import { PICTOS_URL } from "includes/paths";
import Button from "components/Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import generateUUID from "includes/UUID";
import { t } from "i18next";
import { toast } from "react-toastify";
import genRequest from "includes/request";

const { Option } = components;

const getPages = () => [
	{
		title: t("Pages.NEWS"),
		PageId: "Menu1",
		iconName: "News_Picto.png",
		IsMenu: true,
		IsDefault: true,
	},
	{
		title: t("Pages.CORPORATE"),
		PageId: "Menu2",
		iconName: "Corporate_Picto.png",
		IsMenu: true,
		IsDefault: true,
	},
	{
		title: t("Pages.PEOPLES"),
		PageId: "Menu3",
		iconName: "People_Picto.png",
		IsMenu: true,
		IsDefault: true,
	},
	{
		title: t("Pages.CONTACTS"),
		PageId: "Menu4",
		iconName: "Contact_Picto.png",
		IsMenu: true,
		IsDefault: true,
	},
	{
		title: "Menu 5",
		PageId: "Menu5",
		iconName: "",
		IsMenu: true,
		IsDefault: true,
		IsDisabled: true,
	},
	{
		title: t("Pages.PRO_OFFERS"),
		PageId: "ProOffers",
		iconName: "Pro_Offers_Picto.png",
		IsDisabled: true,
	},
	{
		title: t("Pages.OFFERS"),
		PageId: "Offers",
		iconName: "Offers_Picto.png",
		IsDisabled: true,
	},
	{
		title: t("Pages.CAREERS"),
		PageId: "Careers",
		iconName: "Careers_Picto.png",
		IsDisabled: true,
	},
	{
		title: t("Pages.ARTICLES"),
		PageId: "About",
		iconName: "Articles_Picto.png",
		IsDisabled: true,
	},
	{
		title: t("Pages.CHARTS"),
		PageId: "Charts",
		iconName: "Charts_Picto.png",
		IsDisabled: true,
	},
	{
		title: t("Pages.DOCUMENTS"),
		PageId: "Documents",
		iconName: "Docs_Picto.png",
		IsDisabled: true,
	},
	{
		title: t("Pages.AGENDA"),
		PageId: "Agenda",
		iconName: "Animations_Picto.png",
		IsDisabled: true,
	},
];

export default function CustomPagesNames(props) {
	const Pages = getPages();
	const { template } = props;

	const initValues = () => {
		let list = genList();
		return list;
	};

	const lastUpdate = React.useRef(Date.now());
	const [Values, setValues] = useState(initValues());

	function genList() {
		let ret = Pages.map((a) => {
			let exist = template.getMenus(a.PageId ? a.PageId : a.Id);
			if ((exist || a.IsDefault) && !a.IsDisabled)
				return exist
					? {
							...a,
							...exist,
							DefaultTitle: a.title,
							DefaultIcon: a.iconName,
					  }
					: a;
			return false;
		}).filter((a) => a);
		return ret;
	}

	function getFirstUnused() {
		let ret = Pages.filter((a) => {
			if (a.IsDisabled) return false;
			let exist = Values.find((b) => b.PageId === a.PageId);
			return exist ? false : a;
		});
		if (!ret.length) return false;
		return ret[0];
	}

	function addTitle() {
		let first = getFirstUnused();
		let item = {
			PageId: generateUUID(),
			...first,
			DefaultTitle: first.title,
			LastUpdate: Date.now(),
		};
		setValues([...Values, item]);
	}

	function updateItem(pageId, values) {
		let index = Values.findIndex((a) => a.PageId === pageId);

		if (index === -1) return false;
		let ret = [...Values];
		ret[index] = values;
		lastUpdate.current = Date.now();
		setValues(ret);
	}

	function removeItem(pageId) {
		let index = Values.findIndex((a) => a.PageId === pageId);

		if (index === -1) return false;
		let vals = [...Values];
		vals.splice(index, 1);
		setValues(vals);
	}

	function saveItems() {
		let ret = {};

		Values.forEach((a) => {
			ret[a.PageId] = {
				iconName: a.iconName,
				title: a.title || a.DefaultTitle,
			};
		});
		updateAppMenus(ret);
	}

	function updateAppMenus(menus) {
		let proms = [];

		if (props.Templates?.length) {
			for (let x in props.Templates) {
				props.Templates[x].setMenus(menus);
				proms.push(props.Templates[x].send());
			}
			props.setTemplate(props.Templates[0].values());
		}

		let prom = Promise.all(proms).then(() => {
			props.forceRefresh();
		});

		toast.promise(prom, {
			pending: t("Toasts.PROM_PENDING"),
			success: t("Toasts.PROM_SUCCESS"),
			error: t("Toasts.PROM_ERROR"),
			autoClose: 7000,
		});
		return prom;
	}

	// const checkChanges = () => {
	// 	let res = Values.filter((a) => a.LastUpdate || a.LastReset)

	// 	return (res?.length ? true : false )
	// }

	return (
		<div className={"CustomPagesNames " + props.className}>
			<h5>{t("Appearance.CUSTOM_TITLES")}</h5>
			<i>{t("Appearance.CUSTOM_TITLES_MSG")}</i>
			<div className="d-flex flex-column gap-2 mt-3">
				{Values.map((a) => {
					if (a.IsDisabled) return false;
					return (
						<PageCustomInfos
							key={a.PageId}
							lastUpdate={lastUpdate.current}
							page={a}
							title={a.title}
							onChange={updateItem}
							onDelete={removeItem}
							used={Values}
						/>
					);
				})}
			</div>
			<div className="d-flex gap-2 mt-4">
				{getFirstUnused() && (
					<Button
						className="btn-blue"
						text={t("Appearance.ADD_CUSTOM_TITLE")}
						onClick={addTitle}
					/>
				)}
				<Button
					className="btn-green"
					text={t("Commons.SAVE")}
					onClick={saveItems}
				/>
			</div>
		</div>
	);
}

function PageCustomInfos(props) {
	const { page, onChange, onDelete, used } = props;
	if (!page) return false;

	const Pages = getPages();

	const genOptions = () => {
		let ret = Pages.map((a) => {
			let id = a.PageId ? a.PageId : a.Id;
			let isUsed = used.findIndex((b) => b.PageId === id) !== -1;
			if (a.IsDisabled || isUsed) return false;
			return {
				...a,
				DefaultTitle: a.title,
				DefaultIcon: a.iconName,
				label: a.title,
				value: id,
				PageId: id,
				icon: a.iconName,
			};
		}).filter((a) => a);
		return ret;
	};

	const updatePage = (item) => {
		item.lastUpdate = Date.now();
		onChange(page.PageId, item);
	};

	const updateTitle = (value) => {
		let item = { ...page };
		item.title = value;
		item.lastUpdate = Date.now();
		updatePage(item);
	};

	const updateIcon = (icon) => {
		let item = { ...page };
		item.iconName = icon.value;
		updatePage(item);
	};

	const deleteItem = () => {
		onDelete(page.PageId);
	};

	const resetItem = () => {
		let date = Date.now();
		let res = {
			...page,
			title: page.DefaultTitle,
			iconName: page.DefaultIcon,
			LastReset: date,
		};
		updatePage(res);
	};

	let icon = page.iconName || page.DefaultIcon;

	return (
		<div
			className={
				"PageCustomInfos d-flex gap-2 w-100 align-items-center" +
				(page.IsDefault ? " default" : "")
			}
		>
			{!page.IsDefault ? (
				<Button
					className="w-auto unstyled delete-btn"
					onClick={deleteItem}
					title="Supprimer le titre personnalisé"
				>
					<FontAwesomeIcon icon={faTrashAlt} color="red" />
				</Button>
			) : (
				<Button
					className="w-auto unstyled reset-btn"
					onClick={resetItem}
					title="Remettre les valeurs par défaut"
				>
					<FontAwesomeIcon icon={faUndo} color="#0080B9" />
				</Button>
			)}
			<div className="w-100">
				<CustomSelect
					className="IconsSelect light-bg"
					components={{ Option: PageOption, Control: PageLabel }}
					options={genOptions()}
					initialValue={{
						label: page.DefaultTitle,
						value: page.PageId,
						icon: page.iconName,
					}}
					onChange={updatePage}
					isDisabled={page.IsDefault}
				/>
			</div>
			<div className="w-100">
				<FormInput
					value={page.title}
					onChange={updateTitle}
					externvalue={"true"}
				/>
			</div>
			<div className="w-100">
				<IconsSelect
					key={props.lastUpdate}
					onChange={updateIcon}
					initialValue={{ label: icon, value: icon, icon: icon }}
				/>
			</div>
		</div>
	);
}

const IconsSelect = (props) => {
	// The Azure picto container sends no CORS header: the API lists (and
	// on first use imports) the pictos it serves under Pictos/.
	const fetchPictos = () => genRequest("storage/pictos");

	return (
		<QuerySelect
			queryKey={["Pictos"]}
			queryFn={fetchPictos}
			className="IconsSelect light-bg"
			components={{ Option: PageOption, Control: PageLabel }}
			// options={genOptions()}
			menuPosition={"fixed"}
			isMulti={false}
			treat={(a) => {
				return {
					label: a,
					value: a,
					icon: a,
				};
			}}
			{...props}
		/>
	);
};

const PageLabel = ({ children, ...props }) => {
	let value = props.getValue();
	let icon = value[0];

	return (
		<components.Control {...props} className="ps-2">
			<PageIcon {...icon} /> {children}
		</components.Control>
	);
};

const PageIcon = (props) => {
	if (!props.icon) return false;
	return (
		<img
			loading="lazy"
			src={PICTOS_URL + encodeURIComponent(props.icon)}
			style={{ width: props.width || 20 }}
			alt={props.label}
			className={props.className}
		/>
	);
};

const PageOption = (props) => {
	return (
		<Option {...props} className="d-flex align-items-center">
			<img
				loading="lazy"
				src={PICTOS_URL + encodeURIComponent(props.data.icon)}
				style={{ width: 20 }}
				alt={props.data.label}
				className="me-2"
			/>
			{props.data.label}
		</Option>
	);
};
